exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.port-img{\r\n    border: 1px solid #CCC;\r\n}\r\n.portfolio-item .icon-links {\r\n    top: 78px !important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/case-studies/case-studies.component.css
// module id = ../../../../../src/app/case-studies/case-studies.component.css
// module chunks = main